var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "canvas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9997 1.50012V0H14.8199L13.1787 2.84218C12.3335 2.47444 11.4216 2.2848 10.4999 2.28508C6.7777 2.28508 3.74982 5.31297 3.74982 9.03516C3.75078 10.0875 3.99828 11.125 4.47248 12.0645C4.94667 13.004 5.63438 13.8193 6.48048 14.4451L5.29405 16.4999H0V18H6.15758L7.77164 15.2048C8.62956 15.5878 9.55844 15.786 10.4979 15.7867C14.2201 15.7867 17.248 12.7588 17.248 9.0366C17.2474 7.97518 16.9962 6.9289 16.5146 5.98298C16.0331 5.03704 15.335 4.21823 14.4771 3.59322L15.6853 1.50012H20.9997ZM15.7498 9.03516C15.753 10.1617 15.3948 11.2596 14.7278 12.1674C14.0608 13.0753 13.1201 13.7452 12.0441 14.0789C10.9681 14.4125 9.81348 14.3922 8.74985 14.021C7.68623 13.6497 6.76973 12.9471 6.13505 12.0164C5.50034 11.0857 5.18091 9.97588 5.2237 8.85013C5.26649 7.7244 5.66922 6.64208 6.37274 5.7622C7.07624 4.88233 8.04344 4.2513 9.13216 3.96188C10.2209 3.67243 11.3738 3.73984 12.4213 4.15418L9.61988 9.00752H11.3513L13.7212 4.89988C14.3522 5.38892 14.863 6.01577 15.2146 6.73249C15.5662 7.44921 15.7493 8.23684 15.7498 9.03516Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiIcon);
export default __webpack_public_path__ + "static/media/asi-icon.d243092ecf6a340ae29c990a43f1b04a.svg";
export { ForwardRef as ReactComponent };